module.exports = __webpack_public_path__ + "img/4.2cc83057.jpeg";